import PropTypes from 'prop-types'
import React from 'react'
import { toHumanReadableStringDatetimeUtil } from 'utils/datetime'
import { STYLES_PADDING } from 'modules/styles/constants/index.cjs'
import TextBodySmall from 'components/TextBodySmall'

function CommentDate ({ value, wasEdited }) {
  const date = new Date(value)
  let label = toHumanReadableStringDatetimeUtil(date)
  if (wasEdited) {
    label += ' - Edited'
  }
  return (
    <div
      style={{
        width: '100%',
        paddingBottom: STYLES_PADDING.BIG
      }}
    >
      <TextBodySmall>
        {label}
      </TextBodySmall>
    </div>
  )
}

CommentDate.defaultProps = {
  wasEdited: null
}

CommentDate.propTypes = {

  value: PropTypes.string.isRequired,
  wasEdited: PropTypes.bool
}

export default CommentDate
